import Srv from '@/__shared/utils/lib_srv'
import store from '@/site/store'
import { gtag, fbq } from '@/site/analytics/trackers'
import { eventer } from '@/__shared/utils/lib_eventer'
import { isBotAgent } from '@/site/site/prerender'
import gtagUtils from './googleAnalyticsUtils.js'
import fbPixelUtils from './fbPixelUtils.js'

// UPDATE USER ID ------------------------------------------
let _currUserId = null
function updateUser(user) {
	if (!user || _currUserId == user.id) return
	_currUserId = user.id
	gtag('set', { user_id: user.id })
	fbq('init', Srv('Analytics.fbpId'), { external_id: user.id })
}

updateUser(store.get('shop/user'))
store.watch(() => store.get('shop/user'), updateUser)

eventer.listen('product-list:view', ({ products, listId = null, listName = null }) => {
	if (isBotAgent) return
	if (!products?.length) return

	const productsData = products.map((product, i) => ({
		product: product,
		variant: product.selectedVariant,
		index: 'index' in product ? product.index : i,
	}))
	gtag(
		'event',
		'view_item_list',
		gtagUtils.normalizeProductListData(productsData, listId, listName)
	)
})

eventer.listen('product:click', ({ product, variant, listId = null, listName = null, index = 0 }) => {
	if (isBotAgent) return
	variant = variant || product.selectedVariant
	const productsData = [{ product, variant, index }]
	gtag(
		'event',
		'select_item',
		gtagUtils.normalizeProductListData(productsData, listId, listName)
	)
})

eventer.listen('product:view', ({ product, variant }) => {
	if (isBotAgent) return

	let productsData = [{ product, variant }]
	gtag('event', 'view_item', gtagUtils.normalizeProductListData(productsData))

	const data = fbPixelUtils.normalizeProductData(product, variant)
	fbPixelUtils.triggerDoubleEvent('ViewContent', data)
})

// check from here
eventer.listen('user:signup', ({ loginMethod, user }) => {
	if (isBotAgent) return
	gtag('event', 'sign_up', { method: loginMethod, user_id: user.id })
	const data = fbPixelUtils.normalizeUserData(user)
	fbPixelUtils.triggerDoubleEvent('CompleteRegistration', data)
})

eventer.listen('user:signin', ({ loginMethod, user }) => {
	if (isBotAgent) return
	gtag('event', 'login', { method: loginMethod, user_id: user.id })
})

eventer.listen('cart:item-added', ({ product, qty, order }) => {
	if (isBotAgent) return

	gtag('event', 'add_to_cart', gtagUtils.normalizeCartItemData(product, qty))

	const data = fbPixelUtils.normalizeOrderData(order)
	fbPixelUtils.triggerDoubleEvent('AddToCart', data)
})

eventer.listen('cart:item-removed', async ({ product, qty, order }) => {
	if (isBotAgent) return

	gtag('event', 'remove_from_cart', gtagUtils.normalizeCartItemData(product, qty))
})

eventer.listen('checkout:init', async ({ order }) => {
	if (isBotAgent) return

	gtag('event', 'begin_checkout', gtagUtils.normalizeOrderData(order))

	const data = fbPixelUtils.normalizeOrderData(order)
	fbPixelUtils.triggerDoubleEvent('InitiateCheckout', data)
})

eventer.listen('checkout:step-submit', async ({ stepKey, order }) => {
	if (isBotAgent) return

	if (stepKey === 'delivery') {
		gtag('event', 'add_shipping_info', gtagUtils.normalizeOrderData(order))
	} else if (stepKey === 'payment') {
		gtag('event', 'add_payment_info', gtagUtils.normalizeOrderData(order))
	} else if (stepKey === 'contact') {
		const data = fbPixelUtils.normalizeOrderData(order)
		fbPixelUtils.triggerDoubleEvent('AddPaymentInfo', data)
	}
	/*if (stepKey === 'confirm') {
		console.log('Checkout step submit:', stepKey, order.code)
		let gtagPromise = new Promise((resolve) => {
			if (!Srv('Analytics.gaId')) return resolve()
			try {
				let params = gtagUtils.normalizeOrderData(order)
				params.event_callback = resolve
				gtag('event', 'purchase', params)
				setTimeout(resolve, 5000)
			} catch (err) {
				resolve()
			}
		})
		let fbqPromise = new Promise((resolve) => {
			if (!Srv('Analytics.fbpId')) return resolve()
			try {
				Promise.race([
					fbPixelUtils.triggerDoubleEvent('Purchase', fbPixelUtils.normalizeOrderData(order)),
					new Promise((resolve) => setTimeout(resolve, 1000))
				]).then(resolve).catch(() => resolve())
			} catch (err) {
				resolve()
			}
		})

		await Promise.all([gtagPromise, fbqPromise])
	}*/
})

eventer.listen('search:search', ({ searchTerm }) => {
	if (isBotAgent) return

	gtag('event', 'search', { search_term: searchTerm })

	const data = { search_string: searchTerm }
	fbPixelUtils.triggerDoubleEvent('Search', data)
})

eventer.listen('search:view-results', ({ products, searchTerm, listId }) => {
	if (isBotAgent) return

	const productsData = products.map((product, i) => ({
		product: product,
		variant: product.selectedVariant,
		index: 'index' in product ? product.index : i,
	}))
	gtag('event', 'view_search_results', {
		...gtagUtils.normalizeProductListData(productsData, listId),
		search_term: searchTerm,
	})
})